var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationNoteDeclineEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "98A89B89-AC51-4659-AB44-0608CE707063") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Feed-Left",
    transform: "translate(-650.000000, -3478.000000)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(600.000000, 3476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-disapprove",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,20.0001464 L2,3.99985364 C2,2.89484758 2.89317632,2 3.99985364,2 L20.0001464,2 C21.1051524,2 22,2.89317632 22,3.99985364 L22,20.0001464 C22,21.1051524 21.1068237,22 20.0001464,22 L3.99985364,22 C2.89484758,22 2,21.1068237 2,20.0001464 Z M20.0001464,4 L4,3.99985364 L3.99985364,20 L20,20.0001464 L20.0001464,4 Z M12,10.5857864 L14.4780009,8.10778552 C14.8674333,7.71835316 15.498563,7.72038841 15.8890873,8.1109127 C16.2823343,8.50415966 16.2810117,9.13320189 15.8922145,9.52199909 L13.4142136,12 L15.8922145,14.4780009 C16.2810117,14.8667981 16.2823343,15.4958403 15.8890873,15.8890873 C15.498563,16.2796116 14.8674333,16.2816468 14.4780009,15.8922145 L12,13.4142136 L9.52199909,15.8922145 C9.13256673,16.2816468 8.501437,16.2796116 8.1109127,15.8890873 C7.71766575,15.4958403 7.71898833,14.8667981 8.10778552,14.4780009 L10.5857864,12 L8.10778552,9.52199909 C7.71898833,9.13320189 7.71766575,8.50415966 8.1109127,8.1109127 C8.501437,7.72038841 9.13256673,7.71835316 9.52199909,8.10778552 L12,10.5857864 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationNoteDeclineEmpty);
export default __webpack_public_path__ + "static/media/application_note_decline_empty.59cd13102cf3473822a3bfae2ec0ad7a.svg";
export { ForwardRef as ReactComponent };